/**
 * Features for product type management.
 */
export enum LicenseManagementFeature {
  ACCESS_MANAGEMENT = 'access_management',
  TRIAL = 'trial',
}
